import * as React from "react";
 const Toggle = ({ checked, onChange, label, noBorder = false, noMargin = false }) => (
    <div style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "5px 14px",
      marginBottom: noMargin ? "" : "8px",
      backgroundColor: "#F4F4F4",
      border: noBorder ? "none" : "1px solid #E2E5ED",
      borderRadius: "8px"
    }}>
      <span style={{ fontSize: "14px", color: "#324054", fontWeight: 400 }}>{label}</span>
      <label style={{
        position: "relative",
        display: "inline-block",
        width: "44px",
        height: "24px",
        cursor: "pointer"
      }}>
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          style={{ opacity: 0, width: 0, height: 0 }}
        />
        <span style={{
          position: "absolute",
          cursor: "pointer",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: checked ? "#3b82f6" : "#E2E5ED",
          transition: "0.3s",
          borderRadius: "20px",
        }}>
          <span style={{
            position: "absolute",
            height: "18px",
            width: "18px",
            left: checked ? "23px" : "3px",
            top: "3px",
            backgroundColor: checked ? "#fff" : "#868DAA",
            transition: "0.3s",
            borderRadius: "50%",
            boxShadow: "0 1px 3px rgba(0,0,0,0.2)"
          }}></span>
        </span>
      </label>
    </div>
  );
export default Toggle;